module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAABCAYAAACBkCu0AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAC7qADAAQAAAABAAAAAQAAAADzHVlOAAAA/0lEQVRIDe2Wu00EMRiEPz+WWwmk4wgogArogR42oQNqIiXZGiiBEhAhIXcnQOydX4xNChIF+LdGM78fv6WJxqAqFDMx2apf2NiFrdmDu2C0BwYhu5G9C9qLnDpP9JHkHXaIxMGKDZwkTOMsXXtNXlW+uZ8fyqW6c31wJoxoIhjht3q/fsYaj+UHRhcN+q09EGshGCNU1tK0hqar7NUd6A50B7oD3YHuQHegO9Ad+K8DpWVi3ZYQ8tMfQTXqOAlfSp8fSqQ78Ss83k23enlUd6istHqs7CihciYHjw+psYsRHz2fadC0hXVaYYWQ31jyWnsjm3LFVrEaZuasjFu+AYklUwKDFfheAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img03.png
// module id = 4/Us
// module chunks = 1